// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_menu--line"><g id="Union"><path d="M22 20H2V18H22V20Z" style="fill: currentColor"/><path d="M22 13H2V11H22V13Z" style="fill: currentColor"/><path d="M22 6H2V4H22V6Z" style="fill: currentColor"/></g></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_menu--line"><g id="Union"><path d="M22 20H2V18H22V20Z" style="fill: currentColor"/><path d="M22 13H2V11H22V13Z" style="fill: currentColor"/><path d="M22 6H2V4H22V6Z" style="fill: currentColor"/></g></g></svg>`;

export const Menu: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
